import React from "react";

import { i18, trb } from "@utilities";
import { SelectFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, StepperFormRow } from "@components";
import { useSelector } from "react-redux";
import { selectWhoOpenAccountOptions, selectWhoOpenAccountOptionsAll } from "@redux";

export const WhoOpenAccount = ({ control, isFilledByCeo, resetRepFields }) => {
  const whoOpenAccount = useSelector(selectWhoOpenAccountOptions);
  const whoOpenAccountAllOptions = useSelector(selectWhoOpenAccountOptionsAll);

  return (
    <StepperFormRow containerClass={isFilledByCeo ? "d-none" : ""}>
      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientProfile.0.data.whoOpenAccount"
          title={trb(i18.Labels.WhoOpenAccountIfNotCEO)}
          options={isFilledByCeo === undefined ? whoOpenAccountAllOptions : whoOpenAccount}
          optionsLabel="label"
          optionsValue="value"
          onChange={resetRepFields}
          isSearchable
          defaultValue={isFilledByCeo && "CMP1"}
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
